import logo from '../assets/insightshigh-logo-ink.svg'
import Identity from './Identity.jsx'
import { Icon } from './ui.jsx'

// One nav block, identical on every screen. Only the active item and the
// contextual list below the last divider change.
export default function Sidebar({ view, go, stats, unactioned, replies, children, researchedAt, me, openTasks, overdueTasks }) {
  const Item = ({ id, icon, label, count, alert, sub }) => (
    <button
      className={`nav-item ${view === id ? 'active' : ''} ${sub ? 'nav-sub' : ''}`}
      onClick={() => go(id)}
      aria-label={label}
      title={label}
      aria-current={view === id ? 'page' : undefined}
    >
      <Icon name={icon} />
      <span>{label}</span>
      {count != null ? <span className={`nav-count ${alert ? 'alert' : ''}`}>{count}</span> : null}
    </button>
  )

  return (
    <div className="sb">
      <div className="sb-head">
        {/* The wordmark carries the company; the product name sits under it, so
            the header says whose tool this is and which one. */}
        <img className="sb-logo" src={logo} alt="InsightsHIGH" />
        <span className="sb-sub">GTM · CHEMICALS</span>
      </div>

      <div className="sb-nav">
        <div className="nav-group-label">Pipeline</div>
        <Item id="summary" icon="spark" label="Summary" />
        <Item id="accounts" icon="accounts" label="Accounts" count={stats?.researched} />
        {/* The two structural models are views over the same table, so they
            sit under Accounts rather than beside it. The badge is what the
            view shows: Strong plus Possible. */}
        <Item id="wc" icon="scan" label="Working Capital" count={stats?.wc_view} sub />
        <Item id="proc" icon="scan" label="Procurement" count={stats?.proc_view} sub />
        <Item id="contacts" icon="contacts" label="Contacts" count={stats?.contacts} />
        <Item id="appendix" icon="doc" label="Not researched" count={stats?.not_researched} />

        <div className="nav-divider" />

        <div className="nav-group-label">Intelligence</div>
        <Item id="intel" icon="intel" label="Market intel" count={stats?.intel_items} />
        <Item id="triggers" icon="bolt" label="Triggers" count={unactioned} alert={unactioned > 0} />
        <Item id="log" icon="doc" label="Research log" count={stats?.research_log_count} />
        <Item id="prompts" icon="scan" label="Prompts" />

        <div className="nav-divider" />

        <div className="nav-group-label">Outreach</div>
        <Item id="campaigns" icon="mail" label="Campaigns" count={stats?.campaigns} />
        <Item id="tasks" icon="doc" label="Tasks" count={openTasks} alert={overdueTasks > 0} />
        <Item id="replies" icon="reply" label="Replies" count={replies} alert={replies > 0} />

        {children ? (
          <>
            <div className="nav-divider" />
            <div className="sb-ctx">{children}</div>
          </>
        ) : null}
      </div>

      <Identity me={me} />

      <div className="sb-foot">RESEARCH {(researchedAt || '').replace(/-/g, ' ')}</div>
    </div>
  )
}
